import { render, staticRenderFns } from "./BoxesMovementItem.vue?vue&type=template&id=2b96127d&scoped=true&"
import script from "./BoxesMovementItem.vue?vue&type=script&lang=js&"
export * from "./BoxesMovementItem.vue?vue&type=script&lang=js&"
import style0 from "./BoxesMovementItem.vue?vue&type=style&index=0&id=2b96127d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b96127d",
  null
  
)

export default component.exports